/**
 * Datasets 페이지의 탭 식별자. 값과 정규화만 두는 leaf 모듈이다.
 *
 * 탭에는 등급 게이트가 없다. 보관됨 탭도 모든 member 가 본다. 생성자가 자기 Dataset 을 보관한 뒤
 * 다시 찾을 수 있는 곳이 여기뿐이다. 복원 버튼은 상세 창이 행의 `can_write` 로 활성화한다.
 */

export const datasetTabSearchParamKey = "tab";

export type DatasetTab = "datasets" | "bookmarks" | "archived" | "uploads";

export const defaultDatasetTab: DatasetTab = "datasets";
export const bookmarkTabValue: DatasetTab = "bookmarks";
export const archivedTabValue: DatasetTab = "archived";
// 업로드 현황은 구 Uploads 페이지를 대체한 탭이다. 등급 게이트를 두지 않는다. 서버가 목록을
// "내 업로드" 범위로 제한하고, 전체 조회 스위처만 admin 에게 열린다(패널이 판정한다).
export const uploadsTabValue: DatasetTab = "uploads";

export const datasetTabItems = [
  { value: defaultDatasetTab, label: "Dataset" },
  { value: bookmarkTabValue, label: "북마크" },
  { value: uploadsTabValue, label: "업로드 현황" },
  { value: archivedTabValue, label: "보관됨" },
] as const;

export function normalizeDatasetTab(value: string | null | undefined): DatasetTab {
  if (value === bookmarkTabValue) {
    return bookmarkTabValue;
  }
  if (value === uploadsTabValue) {
    return uploadsTabValue;
  }
  if (value === archivedTabValue) {
    return archivedTabValue;
  }
  return defaultDatasetTab;
}
